<!-- src/App.vue -->

<template>
  <!-- <div id="app"> -->
    <router-view />
  <!-- </div> -->
</template>



<script>

export default {
  name: 'App',
  components: {
  },

  mounted() {
  const state = this.$store.state;

  document.title = state.VUE_APP_SHOP_FULLNAME;

  const metaTags = [
    { property: 'og:title', content: state.VUE_APP_SHOP_FULLNAME },
    { property: 'og:description', content: state.VUE_APP_SOCIAL_INTRO },
    { property: 'og:url', content: process.env.VUE_APP_WEB_EXTERNAL_URL },
    { property: 'og:image', content: '/cms-assets/' + state.VUE_APP_SOCIAL_PREVIEW_IMAGE },
    { property: 'og:type', content: 'website' }
  ];

  metaTags.forEach(tag => {
    let meta = document.querySelector(`meta[property="${tag.property}"]`);
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('property', tag.property);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', tag.content);
  });
}
};
</script>

<style>
#app {
  width: 100%;
  text-align: center;
  padding: 0px 0px 0px 0px;
  margin: 0px 0px 0px 0px;
}
</style>